// Automatically serves every Cloudinary image/video in the best format, quality and size for the device.
const HOST = "res.cloudinary.com";
const WIDTHS = [160, 320, 480, 640, 800, 1080, 1280, 1600, 1920, 2560];
const TRANSFORM_RE = /^(?:[a-z]{1,3}_[^/,]+)(?:,[a-z]{1,3}_[^/,]+)*$/;

const split = (url) => {
  const i = url.indexOf("/upload/");
  if (i < 0 || !url.includes(HOST)) return null;
  const head = url.slice(0, i + 8);
  const rest = url.slice(i + 8);
  const first = rest.split("/")[0];
  if (TRANSFORM_RE.test(first) && !/^v\d+$/.test(first)) return null; // already transformed by hand
  return { head, rest };
};

export const cld = (url, opts = "f_auto,q_auto") => {
  const p = typeof url === "string" && split(url);
  return p ? `${p.head}${opts}/${p.rest}` : url;
};

const sizeImg = (img, tries = 0) => {
  const src = img.getAttribute("src");
  if (!src || img.dataset.cldSrc === src) return;
  const p = split(src);
  if (!p) return;
  const w = Math.ceil(img.getBoundingClientRect().width);
  if (!w && tries < 5) { requestAnimationFrame(() => sizeImg(img, tries + 1)); return; }
  img.dataset.cldSrc = src;
  img.srcset = WIDTHS.map((x) => `${p.head}f_auto,q_auto,c_limit,w_${x}/${p.rest} ${x}w`).join(", ");
  img.sizes = w ? `${w}px` : "100vw";
  if (!img.getAttribute("loading")) img.loading = "lazy";
  img.decoding = "async";
};

const optimizeVideo = (v) => {
  const src = v.getAttribute("src");
  if (src && v.dataset.cldSrc !== src) {
    const next = cld(src, "q_auto,vc_auto");
    v.dataset.cldSrc = next;
    if (next !== src) v.setAttribute("src", next);
  }
  const poster = v.getAttribute("poster");
  if (poster) {
    const np = cld(poster, "f_auto,q_auto,c_limit,w_800");
    if (np !== poster) v.setAttribute("poster", np);
  }
};

const scan = (root) => {
  if (root.nodeType !== 1) return;
  if (root.tagName === "IMG") sizeImg(root);
  else if (root.tagName === "VIDEO") optimizeVideo(root);
  root.querySelectorAll?.("img").forEach((i) => sizeImg(i));
  root.querySelectorAll?.("video").forEach(optimizeVideo);
};

export function startCloudinaryOptimizer() {
  if (typeof window === "undefined" || window.__cldOpt) return;
  window.__cldOpt = true;
  scan(document.body);
  new MutationObserver((muts) => {
    muts.forEach((m) => {
      if (m.type === "attributes") scan(m.target);
      else m.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["src", "poster"] });
  let t;
  window.addEventListener("resize", () => {
    clearTimeout(t);
    t = setTimeout(() => document.querySelectorAll("img[data-cld-src]").forEach((img) => {
      const w = Math.ceil(img.getBoundingClientRect().width);
      if (w) img.sizes = `${w}px`;
    }), 200);
  });
}
